<template>
  <v-container fluid class="ma-0 pa-0">
    <notification-container></notification-container>
    <v-card flat color="#f2f4f7">
      <v-toolbar flat short dense class="my-1" color="#f2f4f7">
        <v-toolbar-title class="body-2 text-none toolbar-heading">
          <v-breadcrumbs :items="contextTitle" class="breadcrumb">
          </v-breadcrumbs>
        </v-toolbar-title>
        <v-toolbar-items class="pa-1">
          <slot name="badges"></slot>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-btn icon :href="contextHelpPath" target="_blank" class="mr-4">
          <v-icon color="#429a86">mdi-help-circle</v-icon>
        </v-btn>
      </v-toolbar>
      <v-divider color="#429a86"></v-divider>
      <v-progress-linear class="ma-0" color="#3d92b6" height=10 v-if="showLoader" indeterminate></v-progress-linear>
      <v-row align="center" justify="center" class="px-2">
        <v-col cols=12 xs=12 sm=12 md=12 class="py-0">
        <v-alert class="rounded-0 mb-0 mt-3" prominent :type="notificationVariant" transition="scale-transition" :value="showNotification">
          <v-row align="center">
            <v-col class="grow">
              <span v-html="notificationText"></span>
            </v-col>
            <v-col class="shrink">
              <v-btn icon @click="closeNotification"><v-icon>mdi-close</v-icon></v-btn>
            </v-col>
          </v-row>
        </v-alert>
        </v-col>
      </v-row>
      <v-card-text :class="{enableBlur: showLoader}" color="red">
        <slot></slot>
      </v-card-text>
      <v-card-actions class="ma-2" :class="{enableBlur: showLoader}">
        <v-container class="pa-0 ma-0">
          <slot name="actions"></slot>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import Vue from 'vue'
import NotificationContainer from '@/components/header/notification-container/NotificationContainer.vue'
import { EventBus } from '@/router/bus'

export default {
  name: 'context-page',
  components: {
    NotificationContainer
  },
  data () {
    return {
      notificationVariant: null,
      notificationText: null,
      showNotification: false
    }
  },
  methods: {
    closeNotification () {
      this.showNotification = false
    }
  },
  created () {
    EventBus.$on('system-notification', (data) => {
      this.notificationVariant = data.variant
      this.notificationText = data.message
      this.showNotification = true
    })
  },
  mounted () {
    this.logConsole(this.tab)
  },
  computed: {
    contextHelpPath () {
      if (this.alternativeRoute.length > 0) {
        return (
          Vue.$config.help_root +
          '/' +
          this.alternativeRoute +
          '/' +
          this.tab
        ).replace(/([^:]\/)\/+/g, '$1')
      }
      return (
        Vue.$config.help_root +
        this.$route.path +
        '/' +
        this.tab
      ).replace(/([^:]\/)\/+/g, '$1')
    },
    contextTitle () {
      const contextPathItems = []
      const pathSegments = this.$route.path.split('/')
      for (let i = 1; i < pathSegments.length - 1; i++) {
        const item = {
          text: this.$t('contextPath.' + pathSegments[i].replace(/-/g, '')),
          disabled: true
        }
        contextPathItems.push(item)
      }
      const item = {
        text: this.title,
        disabled: true
      }
      contextPathItems.push(item)
      return contextPathItems
    }
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    alternativeRoute: {
      type: String,
      default: ''
    },
    tab: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    },
    showLoader: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" type="text/scss">
.context-help-header {
  cursor: pointer;
  opacity: 0.7;
  width: 28px;
  height: 28px;
  margin: 0px;
  &:hover {
    opacity: 1;
  }
}

a {
    text-decoration: none;
}

.toolbar-heading {
  font-weight: 600 !important;
}

.v-breadcrumbs__item {
  color: rgba(0, 0, 0, 0.87) !important;
}

.enableBlur {
  filter: blur(1.2px);
  pointer-events: none;
}

</style>
